var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCallContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46184 0L0.453154 0.192118C0.197096 0.192118 0.00505261 0.448276 0.00505261 0.640394C-0.0589619 3.9064 0.453155 6.78818 3.39782 9.73399C6.34249 12.6798 9.09511 13 12.3599 13C12.6159 13 12.808 12.8079 12.808 12.5517L13 9.54187C13 9.28571 12.808 9.09359 12.6159 9.02956L9.60723 8.58128C9.4792 8.58128 9.28716 8.58128 9.22314 8.70936C8.51898 9.41379 8.00687 9.92611 7.81482 10.0542C7.49475 9.92611 6.34249 9.41379 5.0622 8.06896C3.78191 6.78818 3.14176 5.50739 2.94972 5.18719C3.20578 4.93103 3.78191 4.35468 4.29403 3.84236C4.42205 3.71429 4.42205 3.58621 4.42205 3.45813L3.97395 0.384236C3.97395 0.192118 3.7179 0 3.46184 0Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCallContacts);
export default __webpack_public_path__ + "static/media/icon-call-contacts.47afa927245d3c2480d0efd79a72c39e.svg";
export { ForwardRef as ReactComponent };